export default {
  title: "Digital Coupon System",
  sidebar: {
    home: "Home",
    client_information: "Client Information",
    coupon_management: "Coupon Management",
    clinic: "Clinic",
    add_admin_user: "Add Admin User",
    admins: "Admins",
    coupon_list: "Coupon List",
    coupon_create: "Generate Coupon",
    redeem_coupon_information: "Redeem Coupon Information",
    redeem_coupon: "Redeem Coupon",
    patient_list: "Patient List",
    terms_and_conditions: "Terms and Conditions",
    privacy_policy: "Privacy Policy",
    my_profile: "My Profile",
    HIMNCH_patient_list: "HIMNCH Patient List",
    SRHR_patient_list: "SRHR Patient List",
    SRHR_PROGRAM: "SRHR Program",
    MNCH_PROGRAM: "MNCH Program",
    depo_records: "Depo & OC Pills Records",
    health_records: "Reproductive Health Records",
    srhr_patient_list: "SRHR Patient Lists",
    unch_patient_list: "HIMNCH Patient List",
    epharmacy: "E-Pharmacy",
    sale_order_list: "Sale Order List",
    product_master: "Product Master",
    inventory_master: "Inventory Master",
    logistic: "Logistic",
    reports: "Reports",
    CDIC_PROGRAM: "CDIC Program",
    redeem_cdic_coupon: "Redeem CDIC Coupon",
  },
  sign_in_with_microsoft: "Sign in with Microsoft",
  logout: "Logout",
  search_user_by: "Search Users by Name, Email ...",
  depo_record_search_placeholder: "Search Records by Provider Name, Submitter",
  client_search_placeholder: "Search Records by Client's Name, Phone no: or referredBy",
  filter: "Filter",
  Search: "Search",
  coupon_code: "Coupon Code",
  client_name: "Client Name",
  cg_date: "C/G Date",
  cr_date: "C/R Date",
  cr_provider_name: "C/R Provider Name",
  cr_doctor_name: "C/R Doctor Name",
  client_information: "Client Information",
  phone_number: "Phone Number",
  age: "Age",
  number_of_children: "Number of Children",
  cg_count: "C/G Count",
  cr_count: "C/R Count",
  cg_cdic_count: "C/G CDIC Count",
  cr_cdic_count: "C/R CDIC Count",
  coupon_genearated_count: "Coupon Genearated Count",
  coupon_redeemed_count: "Coupon Redeemed Count",
  coupon_redeemed_date: "Coupon Redeemed Date",
  action: "Action",
  add_client: "Add Client",
  add_new_client: "Add New Client",
  name: "Name",
  phone_number_require: "Phone Number",
  state: "Region/State",
  townshship: "Township",
  label: "Label",
  selected_item: "Selected item",
  age_require: "Age",
  number_of_children_req: "Number Of Children",
  pregnancy_status: "Pregnancy Status",
  delivery_site: "Delivery Site",
  anc_visit_status: "ANCare Visit",
  create: "Create",
  cancel: "Cancel",
  gestational_age: "Gestational Age[0-9]",
  search: "Search",
  filter_by: "Filter by :",
  date_by: "Filter by Date",
  admin_name: "Admin Name",
  email: "Email",
  user_role: "User Role",
  date_from_to: "Date Form/To",
  user_ROLE: "User Role",
  actions: "Actions",
  add_admin: "Add Admin",
  select: "Select",
  user_name: "User Name",
  selected_user_role: "Selected User Role",
  SUPER: "SUPER",
  ADMIN: "ADMIN",
  edit: "Edit",
  home: "Home",
  coupon_management: "Coupon Management",
  providers: "Providers",
  add_admin_user: "Add Admin User",
  admins: "Admins",
  welcome: "Welcome",
  login: "Login",
  to: "To",
  admin_user: "Admin User",
  clinic_join_date: "Clinic joining Date",
  clinic_name: "Clinic Name",
  contact_phone_number: "Contact Phone Number",
  register_email: "Register Email",
  provider_name: "Provider Name",
  add_clinic: "Add Clinic",
  clinic: "Clinic",
  add_doctor: "Add Provider",
  gender: "Gender",
  samaId: "SAMA ID ( *optional )",
  academicTitle: "Academic Title ( *optional )",
  medicalDegree: "Medical Degree ( *optional )",
  phoneNumber: "Phone Number",
  add_new_coupon_family: "Add new coupon family",
  add_cf: "Add C/F",
  programName: "Program Name",
  couponFamily: "Coupon Family",
  serviceName: "Service Name",
  program_name: "Program Name",
  coupon_family: "Coupon Family",
  total_numbers_of_coupon: "Total numbers of Coupon",
  total_numbers_of_used_coupon: "Total numbers of used Coupon",
  default: "Default",
  date_of_birth: "Date of birth",
  empty: "---",
  client_phone_number: "Client Phone Number",
  create_coupon_family: "Create Coupon Family",
  selected_program_name: "Selected Program Name",
  service_name: "Service Name",
  number_of_coupons: "Number of Coupons",
  generate_coupon: "Generate Coupon",
  valid_from_to: "Valid From/To",
  dedicated_patient_number: "Dedicated Patient number",
  service_facility_name: "Service (Facility) Name",
  coupon_status: "Coupon Status",
  valid_from: "Valid From",
  valid_to: "Valid To",
  available: "Available",
  redeemed: "Redeemed",
  expired: "Expired",
  NORMAL: "NORMAL",
  client_phone: "Client Phone",
  doctor_name: "Provider Name",
  // dashboard
  patient: "Patient",
  today_coupon_redeem_user_count: "Today Coupon Redeem User Count",
  new_patient_counts: "New Patient Counts",
  coupon: "Coupon",
  total_number_of_coupon: "Total Number of Coupon",
  coupon_generated: "Coupon Generated",
  coupon_redeemed: "Coupon Redeemed",
  number_fo_coupon: "{{number}} of {{numbers}} Coupon Counts",
  coupon_cancel: "Coupon cancel",
  total_patients: "Total Patients",
  continue_the_treatment: "Continue the treatment",
  never_redeemed: "Never Redeemed",
  redeem: "Redeem",
  pending: "Pending",
  geographic_describution: "Geographic Describution",
  generate: "Generate",
  number_of_numbers: "{{number}} of {{numbers}}",
  age_range: "Age {{age}} to {{ages}}",
  total_redeem: "Total Redeem",
  health_care_person_count: "Health Care Person Count",
  provider_counts: "Provider Counts",
  dashboard: "Dashboard",
  required: "Required",
  placeholder_phone: "09964329021",
  ayeyarwady: "Ayeyarwady",
  bago: "Bago",
  yangon: "Yangon",
  patient_information: "Patient Information",
  name_label: "Name:",
  age_label: "Age:",
  gestational_age_label: "Gestational Age:",
  number_of_childeren_label: "Number Of Childeren:",
  contact_phone_number_label: "Contact Phone Number:",
  found_a_patient: "Found a patient",
  not_found_patient: "Not found a patient & phone number",
  advance_filter: "Advance Filter",
  add_advance_filter: "Add Advance Filter",
  confirm: "Confirm",
  redeemed_status: "Redeemed Status",
  region_state: "Region/State",
  township: "Township",
  password: "Password",
  no: "No.",
  log_in: "Log In",
  back_home: "Back Home",
  new_password: "New Password",
  confirmPassword: "Confirm Password",
  you_need_to_change_your_password: "You need to change your password at the first time",
  change_password: "Change Password",
  enter_otp_code: "Enter OTP Code",
  we_send_phone: "We send an OTP code to your phone number",
  if_you_do_not_code: "If you do not get the Code click",
  here: "Here",
  forgot_password: "Forgot Password?",
  doctor_comment: "Provider Comment",
  redeem_coupon: "Redeem Coupon",
  or: "OR",
  scan_coupon_code: "Scan Coupon Code",
  reject: "Reject",
  coupon_family_name: "Coupon Family Name",
  download_excel: "Download coupon Excel file",
  download: "Download",
  clientName: "Client Name",
  doctorName: "Doctor Name",
  clinicName: "Clinic Name",
  patient_name: "Patient Name",
  patient_date_of_birth: "Patient date of Birth",
  status: "Status",
  date: "Date",
  my_profile: "My Profile",
  contact_admin_info: "If you want to update information, Please contact admin!",
  provider_joining_date: "Provider Joining Date",
  label_provider_name: "Provider Name:",
  label_provider_email: "Provider Email:",
  label_doctor_name: "Doctor Name:",
  label_contact_phone_number: "Contact Phone Number:",
  ill: "နေမကောင်း",
  pregnant: "Pregnant",
  other: "တခြား",
  continue_the_process: "Do you want to reject the coupon?",
  redeem_the_process: "Do you want to redeem the coupon?",
  confirmation: "CONFIRMATION",
  contact_phonenumber: "Contact Phone Number",
  privacy_policy: "Privacy Policy",
  terms_and_conditions: "Terms and Conditions",
  current_password: "Current Password",
  need_doctor_comment_to_reject: "Please choose reject reason in Doctor's comments",
  service_category: "Service Category",
  
  family_name: "Family Name",
  selected_comment: "select comment",
  rejected: "Rejected",
  active: "Active",
  inactive: "Inactive",
  unredeem: "Unredeem",
  joined_program: "Joined Program",
  you_must_be_select: "You must be selected `MNCH` program",
  depo_records: "Depo & OC Pills Records",
  health_records: "Reproductive Health Records",
  srhr_patient_list: "SRHR Patient Lists",
  unch_patient_list: "HIMNCH Patient List",
  add_patient_record: "Add patient record",
  referredBy: "Referred By",

  depo_and_ocpills_records: "Depo & OCPills Records",
  monthly_client_record_form: "Monthly Client Record Form",
  add_new_monthly_client: "Add New Client",
  reporting_from: "Reporting From",
  reporting_to: "Reporting To",
  submitted_date: "Submitted Date",
  submitted_by: "Submitted By",
  client_role: "Client Role",
  client_age: "Client Age",
  consultation: "Consultation",
  dose_count: "Dose Count",
  dmpa_im_New_client_Under_25: "Depo new < 25",
  dmpa_im_New_client_Over_25: "Depo new > 25",
  dmpa_im_Old_client_Under_25: "Depo old < 25",
  dmpa_im_Old_client_Over_25: "Depo old > 25",
  oc_pill_New_client_Under_25: "OC Pills new < 25",
  oc_pill_New_client_Over_25: "OC Pills new > 25",
  oc_pill_Old_client_Under_25: "OC Pills old < 25",
  oc_pill_Old_client_Over_25: "OC Pills old > 25",
  resend_sms: "Resend SMS",
  // health
  client_Name: "Client Name",
  // client_age:"Client Age",
  clinic_visit_date: "Clinic Visit Date",
  // township:"Township",
  // state:"State",
  Ph_Number: "Ph Number",
  Gender: "Gender",
  Parity: "Parity",
  Occasion: "Occasion",
  User: "User",
  Birth_Spacing_Method: "Birth Spacing Method",
  Insertion: "Insertion",
  CCP_awareness: "CCP awareness",
  CCP_Screening: "CCP Screening",
  CCP_Treatment: "CCP Treatment",
  AYFHS_STI: "AYFHS STI",
  AYFHS_Birth_Spacing: "AYFHS Birth Spacing",
  AYFHS_RH_Problems: "AYFHS RH Problems",
  GVB_Awareness: "GVB Awareness",
  GVB_Hotline: "GVB Hotline",
  Disability: "Disability",
  Seeing: "Seeing",
  Difficulty_Level: "Difficulty Level",
  Hearing: "Hearing",
  // Difficulty_Level:"Difficulty Level",
  Walking: "Walking",
  // Difficulty_Level:"Difficulty Level",
  Concentration: "Concentration",
  // Difficulty_Level:"Difficulty Level",
  Self_Care: "Self-Care",
  // Difficulty_Level:"Difficulty Level",
  Communication: "Communication",
  // Difficulty_Level:"Difficulty Level",
  // form
  Client_Data_Collection: "Client Data Collection ",
  RH_Services: "RH Services",
  Client_Disability_Data_Form: "Client’s Disability Data Form",
  Clinic_Visit_Date: "Clinic Visit Date",
  Long_Term_Birth_Spacing_Service: "Long Term Birth Spacing Service",
  Cervical_Cancer_Prevention_Services: "Cervical Cancer Prevention Services",
  Adolescent_Youth_Friendly_Health_Services_AYFHS:
    "Adolescent Youth Friendly Health Services AYFHS (10-24 years)",
  Gender_Based_Violence: "Gender Based Violence (GBV)",
  Reproductive_Health_Records_Panel: "Reproductive Health Records Panel",
  Reproductive_Health_Records: "Reproductive Health Records",
  Add_New_Record: "Add New Record",
  parity_input: "Parity (e.g. 1+1, 1+0, 0+1)",
  Client_Birth_Spacing_Usage: "Client’s Birth Spacing Usage",
  What_is_the_main_birth_spacing_method_using_now:
    "What is the main birth spacing method using now?",
  IUD_Removal: "IUD Removal?",
  Reason_for_IUD_Removal: "Reason for IUD Removal",
  What_is_the_other_reason_for_IUD_removal: "What is the other reason for IUD removal?",
  old_user: "Old User",
  user: "User",
  Yes: "Yes",
  No: "No",
  Implant_Removal: "Implant  Removal?",
  What_is_the_other_reason_for_Implant_removal: "What is the other reason for Implant removal?",
  Cervical_Cancer_Prevention_Services_CCP: "Cervical Cancer Prevention Services (CCP)",
  Adolescent_Youth_Friendly_Health_Services_AYFHS_10_24:
    "Adolescent Youth Friendly Health Services AYFHS (10-24 years)",
  Gender_Based_Violence_GBV: "Gender Based Violence (GBV)",
  Client_Disability_Data: "Client Disability Data",
  rh_services: "RH Services",
  male: "Male",
  female: "Female",
  client_phoneNumber: "Client Phone Number",
  client_visit_date: "Client Visit Date",
  next: "Next",
  add_new: "Add New",
  continue: "Continue",
  save: "Save",
  SRHR_Client_Data_Records: "SRHR Client Data Records",
  client_region: "Client Region",
  client_township: "Client Township",
  client_gender: "Client Gender",
  client_region_name: "Client Region Name",
  client_township_name: "Client Township Name",
  product_master: "Product Master",
  add_new_product: "Add New Product",
  product_name: "Product Name",
  main_group: "Main Group",
  sub_group: "Sub Group",
  sku_code: "SKU Code",
  strength_value: "Strength Value",
  category: "Category",
  sub_category: "Sub Category",
  expiry_date: "Expiry Date",
  pack_size: "Pack size",
  authorized_distributer: "Authorized Distributer",
  min_purchase_amount: "Minimum Purchase Amount",
  purchase_increase_count: "Purchase Increasement count",
  selling_unit: "Selling Unit (UOM)",
  selling_price: "Selling Price",
  manufacture_name: "Manufacture Name",
  made_in_country: "Made In (Country)",
  chemical_name: "Chemical Name (Generic)",
  dosage: "Dosage",
  action_and_indication: "Action and Indication",
  potential_side_effects: "Potential side Effects",
  product_description: "Product Description",
  update_image: "Upload Image",
  stock_status: "Stock Status",
  category_name: "Category Name",
  generic: "Generic",
  filterProductName: "Product Name",
  filterSKU: "SKU",
  filterCategory: "Category",
  filterChemicalName: "Chemical Name",
  upload_image: "Upload Image",
  suk_code: "SKU Code",
  batch_number: "Batch Number",
  code_storage_item: "Cold Storage Item",
  stock_fill_amount: "Stock fill amount",
  add_new_inventory: "Add new Inventory",
  inventory_master: "Inventory Master",
  inventory_create: "create inventory",
  oirder_ID: "Order ID",
  order_date: "Order Date",
  // client_name: "Client Name",
  payment_status: "Payment Status",
  order_status: "Order Status",
  order_cancel: "Order Cancel",
  order_type: "Order Type",
  total_amount: "Total Amount",
  // provider_name: "Provider Name",
  provider: "Provider Township",
  // phone_number: "Phone Number",
  delivery_address: "Delivery Address",
  sale_order_form: "Sale Order Form",
  sale_order_list: "Sale Order List",
  add_new_sale_order: "Add New Sale Order",
  quality: "Quality",
  price_per_unit: "Price Per Unit",
  price_per_quality: "Price Per Quality",
  discount_type: "Discount Type",
  discount_amount: "Discount Amount",
  discount_price: "Discount Price",
  // total_amount:"Total Amount"
  choose_discount: "Choose Discount",
  flat: "Flat",
  percentage: "Percentage",
  search_product: "Search Product",
  delete: "Delete",
  add_promo: "Add promotion",
  add_discount: "Add Discount",
  gross_amount: "Gross Amount",
  net_amount: "Net Amount",
  discount: "Discount",
  gestational_age_of_1_st_AN_care_visit: "Gestational age of 1 st AN care visit",
  total_numbers_of_AN_care_visit: "Total numbers of AN care visit",
  confirm_password: "Confirm Password",
  fromDate: "From Date",
  toDate: "To Date",
  couponCode: "Coupon Code",
  hospital_name: "Hospital Name",
  insulinType: "Insulin Type",
  remark: "Remark",
  mandalay: "Mandalay",
  magway: "Magway",
  mon: "Mon",
  rakhine: "Rakhine",
  shan: "Shan",
  naypyitaw: "Naypyitaw",
  others: "Others",
  noOfCoupons: "No. of Coupons",
  no_of_coupons: "No. of Coupons",
  created_at: "Created At",
  updated_at: "Updated At",
  coupon_program_name: "Coupon Program Name",
  cdic_clients: "CDIC patients",
  redeem_cdic_coupon: "Redeem CDIC Coupon",
  generate_cdic_coupon: "Generate CDIC Coupon",
  cdic_coupon_management: "CDIC Coupon Management",
  cdic_client_information: "CDIC Client Information",
  cdic_redeem_coupon_management: "CDIC Redeemed Coupon Management",
  claimed_count: "Claimed Count",
  cdic_program_management: "CDIC Program Management",
  available_coupons: "No. of available coupons",
  bago_east: "Bago East",
  bago_west: "Bago West",
  chin: "Chin State",
  kachin: "Kachin",
  kayah: "Kayah",
  kayin: "Kayin",
  sagaing: "Sagaing",
  shan_east: "Shan East",
  shan_south: "Shan South",
  shan_north: "Shan North",
  tanintharyi: "Tanintharyi",
  Bogale: "ဘိုကလေး",
  Danubyu: "ဓနုဖြူ",
  Dedaye: "ဒေးဒရဲ",
  Einme: "အိမ်မဲ",
  Hinthada: "ဟင်္သာတ",
  Ingapu: "အင်္ဂပူ",
  Kangyidaunt: "ကန်ကြီးထောင့်",
  Kyaiklat: "ကျိုက်လတ်",
  Kyangin: "ကြံခင်း",
  Kyaunggon: "ကျောင်းကုန်း",
  Kyonpyaw: "ကျုံပျော်",
  Labutta: "လပွတ္တာ",
  Lemyethna: "လေးမျက်နှာ",
  Maubin: "မအူပင်",
  Mawlamyinegyun: "မော်လမြိုင်ကျွန်း",
  Myanaung: "မြန်အောင်",
  Myaungmya: "မြောင်းမြ",
  Ngapudaw: "ငပုတော",
  Nyaungdon: "ညောင်တုန်း",
  Pantanaw: "ပန်းတနော်",
  Pathein: "ပုသိမ်",
  Pyapon: "ဖျာပုံ",
  Thabaung: "သာပေါင်း",
  Wakema: "ဝါးခယ်မ",
  Yegyi: "ရေကြည်",
  Zalun: "ဇလွန်",
  Bago: "ပဲခူး",
  Daik_U: "ဒိုက်ဦး",
  Htantabin: "ထန်းတပင်",
  Kawa: "ကဝ",
  Kyaukkyi: "ကျောက်ကြီး",
  Kyauktaga: "ကျောက်တံခါး",
  Nyaunglebin: "ညောင်လေးပင်",
  Oktwin: "အုတ်တွင်း",
  Phyu: "ဖြူး",
  Shwegyin: "ရွှေကျင်",
  Taungoo: "တောင်ငူ",
  Thanatpin: "သနပ်ပင်",
  Waw: "ဝေါ",
  Yedashe: "ရေတာရှည်",
  Gyobingauk: "ကြို့ပင်ကောက်",
  Letpadan: "လက်ပံတန်း",
  Minhla: "မင်းလှ",
  Monyo: "မိုးညို",
  Nattalin: "နတ်တလင်း",
  Okpho: "အုတ်ဖို",
  Padauk: "ပန်းတောင်း",
  Paukkhaung: "ပေါက်ခေါင်း",
  Paungde: "ပေါင်းတည်",
  Pyay: "ပြည်",
  Shwedaung: "ရွှေတောင်",
  Thayarwady: "သာယာဝတီ",
  Thegon: "သဲကုန်း",
  Zigon: "ဇီးကုန်း",
  Falam: "ဖလမ်း",
  Hakha: "ဟားခါး",
  Kanpetlet: "ကန်ပက်လက်",
  Matupi: "မတူပီ",
  Mindat: "မင်းတပ်",
  Paletwa: "ပလက်ဝ",
  Tedim: "တီးတိန်",
  Thantlang: "ထန်တလန်",
  Tonzang: "တွန်းဇန်",
  Bhamo: "ဗန်းမော်",
  Chipwi: "ချီ",
  Hpakant: "ဖားကန့်",
  Injangyang: "အင်ဂျန်းယန်",
  Khaunglanhpu: "ခေါင်လန်ဖူး",
  Machanbaw: "မချမ်းဘော",
  Mansi: "မံစီ",
  Mogaung: "မိုးကောင်း",
  Mohnyin: "မိုးညှင်း",
  Momauk: "မိုးမောက်",
  Myitkyina: "မြစ်ကြီးနား",
  Nawngmun: "နောင်မွန်း",
  Puta_O: "ပူတာအို",
  Shwegu: "ရွှေကူ",
  Sumprabum: "ဆွမ်ပရာဘွမ်",
  Tanai: "တနိုင်း",
  Tsawlaw: "ဆော့လော်",
  Waingmaw: "ဝိုင်းမော်",
  Bawlake: "ဘောလခဲ",
  Demoso: "ဒီးမော့ဆို",
  Hpasawng: "ဖားဆောင်း",
  Hpruso: "ဖရူဆို",
  Loikaw: "လွိုင်ကော်",
  Mese: "မယ်စဲ့",
  Shadaw: "ရှားတော",
  Hlaingbwe: "လှိုင်းဘွဲ့",
  Hpa_An: "ဘားအံ",
  Hpapun: "ဖာပွန်",
  Kawkareik: "ကော့ကရိတ်",
  Kyainseikgyi: "ကြာအင်းဆိပ်ကြီး",
  Myawaddy: "မြဝတီ",
  Thandaunggyi: "သံတောင်ကြီး",
  Aunglan: "အောင်လံ",
  Chauk: "ချောက်",
  Gangaw: "ဂန့်ဂေါ",
  Kamma: "ကံမ",
  Magway: "မကွေး",
  Minbu: "မင်းဘူး",
  Mindon: "မင်းတုန်း",
  // Minhla: "မင်းလှ",
  Myaing: "မြိုင်",
  Myothit: "မြို့သစ်",
  Natmauk: "နတ်မောက်",
  Ngape: "ငဖဲ",
  Pakokku: "ပခုက္ကူ",
  Pauk: "ပေါက်",
  Pwintbyu: "ပွင့်ဖြူ",
  Salin: "စလင်း",
  Saw: "ဆော",
  Seikphyu: "ဆိပ်ဖြူ",
  Sidoktaya: "စေတုတ္ထရာ",
  Sinbaungwe: "ဆင်ပေါင်ဝဲ",
  Taungdwingyi: "တောင်တွင်းကြီး",
  Thayet: "သရက်",
  Tilin: "ထီးလင်း",
  Yenangyaung: "ရေနံချောင်း",
  Yesagyo: "ရေစကြို",
  Amarapura: "အမရပူရ",
  Aungmyaythazan: "အောင်မြေသာစံ",
  Chanayethazan: "ချမ်းအေးသာစံ",
  Chanmyathazi: "ချမ်းမြသာစည်",
  Kyaukpadaung: "ကျောက်ပန်းတောင်း",
  Kyaukse: "ကျောက်ဆည်",
  Madaya: "မတ္တရာ",
  Mahaaungmyay: "မဟာအောင်မြေ",
  Mahlaing: "မလှိုင်",
  Meiktila: "မိတ္ထီလာ",
  Mogoke: "မိုးကုတ်",
  Myingyan: "မြင်းခြံ",
  Myittha: "မြစ်သား",
  Natogyi: "နွားထိုးကြီး",
  Ngazun: "ငါန်းဇွန်",
  Nyaung_U: "ညောင်ဦး",
  Patheingyi: "ပုသိမ်ကြီး",
  Pyawbwe: "ပျော်ဘွယ်",
  Pyigyitagon: "ပြည်ကြီးတံခွန်",
  Pyinoolwin: "ပြင်ဦးလွင်",
  Singu: "စဉ့်ကူး",
  Sintgaing: "စဉ့်ကိုင်",
  Tada_U: "တံတားဦး",
  Taungtha: "တောင်သာ",
  Thabeikkyin: "သပိတ်ကျင်း",
  Thazi: "သာစည်",
  Wundwin: "ဝမ်းတွင်း",
  Yamethin: "ရမည်းသင်း",
  Bilin: "ဘီးလင်း",
  Chaungzon: "ချောင်းဆုံ",
  Kyaikmaraw: "ကျိုက်မရော",
  Kyaikto: "ကျိုက်ထို",
  Mawlamyine: "မော်လမြိုင်",
  Mudon: "မုဒုံ",
  Paung: "ပေါင်",
  Thanbyuzayat: "သံဖြူဇရပ်",
  Thaton: "သထုံ",
  Ye: "ရေး",
  Det_Khi_Na_Thi_Ri: "ဒက္ခိဏသီရိ",
  Lewe: "လယ်ဝေး",
  Oke_Ta_Ra_Thi_Ri: "ဥတ္တရသီရိ",
  Poke_Ba_Thi_Ri: "ပုဗ္ဗသီရိ",
  Pyinmana: "ပျဉ်းမနား",
  Tatkon: "တပ်ကုန်း",
  Za_Bu_Thi_Ri: "ဇမ္ဗူသီရိ",
  Zay_Yar_Thi_Ri: "ဇေယျာသီရိ",
  Ann: "အမ်း",
  Buthidaung: "ဘူးသီးတောင်",
  Gwa: "ဂွ",
  Kyaukpyu: "ကျောက်ဖြူ",
  Kyauktaw: "ကျောက်တော်",
  Maungdaw: "မောင်တော",
  Minbya: "မင်းပြား",
  Mrauk_U: "မြောက်ဦး",
  Munaung: "မာန်အောင်",
  Myebon: "မြေပုံ",
  Pauktaw: "ပေါက်တော",
  Ponnagyun: "ပုဏ္ဏားကျွန်း",
  Ramree: "ရမ်းဗြဲ",
  Rathedaung: "ရသေ့တောင်",
  Sittwe: "စစ်တွေ",
  Thandwe: "သံတွဲ",
  Toungup: "တောင်ကုတ်",
  Ayadaw: "အရာတော်",
  Banmauk: "ဗန်းမောက်",
  Budalin: "ဘုတလင်",
  Chaung_U: "ချောင်းဦး",
  Hkamti: "ခန္တီး",
  Homalin: "ဟုမ္မလင်း",
  Indaw: "အင်းတော်",
  Kale: "ကလေး",
  Kalewa: "ကလေးဝ",
  Kanbalu: "ကန့်ဘလူ",
  Kani: "ကနီ",
  Katha: "ကသာ",
  Kawlin: "ကောလင်း",
  Khin_U: "ခင်ဦး",
  Kyunhla: "ကျွန်းလှ",
  Lahe: "လဟယ်",
  Layshi: "လေရှီး",
  Mawlaik: "မော်လိုက်",
  Mingin: "မင်းကင်း",
  Monywa: "မုံရွာ",
  Myaung: "မြောင်",
  Myinmu: "မြင်းမူ",
  Nanyun: "နန်းယွန်း",
  Pale: "ပုလဲ",
  Paungbyin: "ဖောင်းပြင်",
  Pinlebu: "ပင်လည်ဘူး",
  Sagaing: "စစ်ကိုင်း",
  Salingyi: "ဆားလင်းကြီး",
  Shwebo: "ရွှေဘို",
  Tabayin: "ဒီပဲယင်း",
  Tamu: "တမူး",
  Taze: "တန့်ဆည်",
  Tigyaing: "ထီးချိုင့်",
  Wetlet: "ဝက်လက်",
  Wuntho: "ဝန်းသို",
  Ye_U: "ရေဦး",
  Yinmarbin: "ယင်းမာပင်",
  Ho_Tawng: "ဟိုတောင်း",
  Kengtung: "ကျိုင်းတုံ",
  Mong_Hpen: "မိုင်းဖျန်",
  Mong_Kar: "မိုင်းကာ",
  Mong_Pawk: "မိုင်းပေါက်",
  Monghpyak: "မိုင်းဖြတ်",
  Monghsat: "မိုင်းဆတ်",
  Mongkhet: "မိုင်းခတ်",
  Mongla: "မိုင်းလား",
  Mongping: "မိုင်းပျဉ်း",
  Mongton: "မိုင်းတုံ",
  Mongyang: "မိုင်းယန်း",
  Mongyawng: "မိုင်းယောင်း",
  Nam_Hpai: "နမ့်ဖိုင်",
  Tachileik: "တာချီလိတ်",
  Aik_Chan: "အိုက်ချန်",
  Chinshwehaw_Sub_township: "ချင်းရွှေဟော်မြို့နယ်ခွဲ (အထူးဒေသ ၁)",
  Hkun_Mar: "ခွန်းမား",
  Hopang: "ဟိုပန်",
  Hsawng_Hpa: "ဆောင်ဖ",
  Hseni: "သိန္နီ",
  Hsipaw: "သီပေါ",
  Ka_Lawng_Hpar: "ကလောင်ဖါ",
  Kawng_Min_Hsang: "ကောင်မင်ဆန်း",
  Konkyan: "ကုန်းကြမ်း",
  Konkyan_Kokang_SAZ: "ကုန်းကြမ်း (အထူးဒေသ ၁)",
  Kunlong: "ကွမ်းလုံ",
  Kutkai: "ကွတ်ခိုင်",
  Kyaukme: "ကျောက်မဲ",
  Lashio: "လားရှိုး",
  Laukkaing: "လောက်ကိုင်",
  Laukkaing_Kokang_SAZ: "လောက်ကိုင် (အထူးဒေသ ၁)",
  Lin_Haw: "လင်ဟော်",
  Long_Htan: "လုံထန်",
  Mabein: "မဘိမ်း",
  Man_Man_Hseng: "မန်မန်ဆိုင်",
  Man_Tun: "မန်တွန်း",
  Manton: "မန်တုံ",
  Matman: "မက်မန်း",
  Mongmao: "မိုင်းမော",
  Mongmit: "မိုးမိတ်",
  Mongyai: "မိုင်းရယ်",
  Muse: "မူဆယ်",
  Nam_Hkam_Wu: "နမ်ခမ်းဝူး",
  Nam_Tit: "နမ့် တစ်",
  Namhkan: "နမ့်ခမ်း",
  Namhsan: "နမ့်ဆန်",
  Namtu: "နမ္မတူ",
  Nar_Kawng: "နားကောင်",
  Nar_Wee: "နာဝီး",
  Narphan: "နားဖန်း",
  Nawng_Hkit: "နောင်ခစ်",
  Nawnghkio: "နောင်ချို",
  Pang_Hkam: "ပန်ခမ့်",
  Pang_Yang: "ပန်ယန်း",
  Pangsang_Panghkam: "ပန်ဆန်း (ပန်ခမ်း)",
  Pangwaun: "ပန်ဝိုင်",
  Tangyan: "တန့်ယန်း",
  Yawng_Lin: "ယောင်လင်း",
  Yin_Pang: "ရင်ဖန့်",
  Hopong: "ဟိုပုံး",
  Hsihseng: "ဆီဆိုင်",
  Kalaw: "ကလော",
  Aungban: "အောင်ပန်း",
  Shwe_Nyaung: "ရွှေညောင်",
  Kunhing: "ကွန်ဟိန်း",
  Kyethi: "ကျေးသီး",
  Laihka: "လဲချား",
  Langkho: "လင်းခေး",
  Lawksawk: "ရပ်စောက်",
  Loilen: "လွိုင်လင်",
  Mawkmai: "မောက်မယ်",
  Monghsu: "မိုင်းရှူး",
  Mongkaing: "မိုင်းကိုင်",
  Mongnai: "မိုးနဲ",
  Mongpan: "မိုင်းပန်",
  Nansang: "နမ့်စန်",
  Nyaungshwe: "ညောင်ရွှေ",
  Pekon: "ဖယ်ခုံ",
  Pindaya: "ပင်းတယ",
  Pinlaung: "ပင်လောင်း",
  Taunggyi: "တောင်ကြီး",
  Ywangan: "ရွာငံ",
  Bokpyin: "ဘုတ်ပြင်း",
  Dawei: "ထားဝယ်",
  Kawthoung: "ကော့သောင်း",
  Kyunsu: "ကျွန်းစု",
  Launglon: "လောင်းလုံး",
  Myeik: "မြိတ်",
  Palaw: "ပုလော",
  Tanintharyi: "တနင်္သာရီ",
  Thayetchaung: "သရက်ချောင်း",
  Yebyu: "ရေဖြူ",
  Ahlone: "အလုံ",
  Bahan: "ဗဟန်း",
  Botahtaung: "ဗိုလ်တထောင်",
  Cocokyun: "ကိုကိုးကျွန်း",
  Dagon: "ဒဂုံ",
  Dagon_Myothit_East: "ဒဂုံမြို့သစ် (အရှေ့ပိုင်း)",
  Dagon_Myothit_North: "ဒဂုံမြို့သစ် (မြောက်ပိုင်း)",
  Dagon_Myothit_Seikkan: "ဒဂုံမြို့သစ် (ဆိပ်ကမ်း)",
  Dagon_Myothit_South: "ဒဂုံမြို့သစ် (တောင်ပိုင်း)",
  Dala: "ဒလ",
  Dawbon: "ဒေါပုံ",
  Hlaing: "လှိုင်",
  Hlaingtharya: "လှိုင်သာယာ",
  Hlegu: "လှည်းကူး",
  Hmawbi: "မှော်ဘီ",
  // Htantabin: "ထန်းတပင်",
  Insein: "အင်းစိန်",
  Kamaryut: "ကမာရွတ်",
  Kawhmu: "ကော့မှူး",
  Kayan: "ခရမ်း",
  Kungyangon: "ကွမ်းခြံကုန်း",
  Kyauktada: "ကျောက်တံတား",
  Kyauktan: "ကျောက်တန်း",
  Kyeemyindaing: "ကြည့်မြင်တိုင်",
  Lanmadaw: "လမ်းမတော်",
  Latha: "လသာ",
  Mayangone: "မရမ်းကုန်း",
  Mingaladon: "မင်္ဂလာဒုံ",
  Mingalartaungnyunt: "မင်္ဂလာတောင်ညွန့်",
  North_Okkalapa: "မြောက်ဥက္ကလာပ",
  Pabedan: "ပန်းဘဲတန်း",
  Pazundaung: "ပုဇွန်တောင်",
  Sanchaung: "စမ်းချောင်း",
  Seikgyikanaungto: "ဆိပ်ကြီး/ခနောင်တို",
  Seikkan: "ဆိပ်ကမ်း",
  Shwepyithar: "ရွှေပြည်သာ",
  South_Okkalapa: "တောင်ဥက္ကလာပ",
  Taikkyi: "တိုက်ကြီး",
  Tamwe: "တာမွေ",
  Thaketa: "သာကေတ",
  Thanlyin: "သန်လျင်",
  Thingangyun: "သင်္ဃန်းကျွန်း",
  Thongwa: "သုံးခွ",
  Twantay: "တွံတေး",
  Yankin: "ရန်ကင်း",
  Hlaingtharya_East: "လှိုင်သာယာ (အရှေ့ပိုင်း)",
  Hlaingtharya_West: "လှိုင်သာယာ (အနောက်ပိုင်း)",
  add_service: "Add Service",
  create_service: "Create Service",
  created_date: "Created Date",
  download_active_coupon_excel: "Download Active Coupon Excel",
  download_coupons: "Download Coupons",
  select_date_range: "Select Date Range",
  coming_soon: "Coming Soon",
  select_coupon_family: "Select Coupon Family",
  export_coupons: "Export Coupons",
  add_new_service: "Add New Service",
  export_data_by_filter: "Export Data By Filter",
  insulin_type: "Insulin Type",
  coupon_generated_date: "Coupon Generated Date",
  download_cdic_client_excel: "Download CDIC Client Excel",
  download_mnch_client_excel: "Download MNCH Client Excel",
};
